"use client";

import { useEffect } from "react";

const CoreWebVitalsOptimizer: React.FC = () => {
  useEffect(() => {
    // Critical performance optimizations
    const optimizePerformance = () => {
      // 1. Optimize images
      const images = document.querySelectorAll("img");
      images.forEach((img) => {
        if (!img.loading) {
          img.loading = "lazy";
        }
        if (!img.decoding) {
          img.decoding = "async";
        }
      });

      // 2. Optimize background images
      const elementsWithBg = document.querySelectorAll(
        '[style*="background-image"]',
      );
      elementsWithBg.forEach((element) => {
        (element as HTMLElement).style.willChange = "background-image";
        (element as HTMLElement).style.transform = "translateZ(0)";
      });

      // 3. Preload critical resources
      const preloadCriticalResources = () => {
        const criticalImages = [
          "/static/certbar-logo.png",
          "/static/certbar-logo-white.png",
        ];

        criticalImages.forEach((src) => {
          const link = document.createElement("link");
          link.rel = "preload";
          link.as = "image";
          link.href = src;
          document.head.appendChild(link);
        });
      };

      preloadCriticalResources();

      // 4. Optimize animations
      const optimizeAnimations = () => {
        const animatedElements = document.querySelectorAll(
          '[class*="animate-"], [class*="transition-"]',
        );
        animatedElements.forEach((element) => {
          (element as HTMLElement).style.willChange = "transform, opacity";
        });
      };

      optimizeAnimations();

      // 5. Reduce layout thrashing
      const reduceLayoutThrashing = () => {
        // Batch DOM reads and writes
        requestAnimationFrame(() => {
          const elements = document.querySelectorAll(
            ".hero-section, .header, .banner",
          );
          elements.forEach((element) => {
            (element as HTMLElement).style.contain = "layout style paint";
          });
        });
      };

      reduceLayoutThrashing();
    };

    // Run optimizations after initial render
    const timeoutId = setTimeout(optimizePerformance, 100);

    // Cleanup
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return null;
};

export default CoreWebVitalsOptimizer;
